import React, { useState } from "react";
import { format, isValid, parseISO, isSameDay } from "date-fns";
import CalendarEventMins from "./calendar-event-mins";
import EventPopup from "./event-popup";
import { convertUTCToLocal } from "../../common/constant/constant";

const DayView = ({
  currentDate,
  allEvents,
  cancelMeeting,
  calOpen,
  setCalOpen,
  setMeetId,
  closePopup,
  selectedEvent,
  setSelectedEvent,
  setTrialInfo,
  handleCall,
  callCount,
  fetchEvents,
  addToast
}) => {
  const [popupPosition, setPopupPosition] = useState(null);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const validDate = isValid(currentDate) ? currentDate : new Date();
  const isToday = isSameDay(validDate, new Date());
  const totalCalls = callCount.filter(x=>x.date == format(validDate, "yyyy-MM-dd"))?.[0]?.totalCalls || 0;
  const remainingCalls = callCount.filter(x=>x.date == format(validDate, "yyyy-MM-dd"))?.[0]?.remainingCalls || 0;

  return (
    <div className="mt-4 bg-white shadow-md rounded-lg overflow-hidden">
      <div className="grid grid-cols-[80px_1fr] text-center font-bold bg-gray-100 border-b calendar-weekdays-header">
        <div className="border-r table_border"></div>
        {isValid(validDate) ? (
          <div className={`text-left p-2 ${isToday ? "blue_color active font-bold" : ""}`}>
            <div>
              {/* {format(validDate, "EEEE, MMMM d, yyyy")} */}
              <>
                <span className={`date-big-fonts ${isToday ? "selected_date-big-fonts" : ""}`}>{format(validDate, "dd")}</span>
                <br />
                <span className={`date-small-fonts ${isToday ? "selected_date-small-fonts" : ""}`}>{format(validDate, "EEEE")}</span>
              </>
            </div>
            <div className="mt-1">
              <div className="text-xs font-medium mb-1">
                <span className="text-[#1B2A3D] font-[500px]">Total Count</span>
                <span className="ml-3 bg-[#D2E2FF] text-[#4B69E4] py-[2px] px-[4px] rounded font-semibold"> {totalCalls.toString().padStart(2, "0")} </span>
              </div>
              <div className="text-xs font-medium mb-1">
                <span className="text-[#1B2A3D] font-[500px]">{format(validDate, "yyyy-MM-dd") < format(new Date(), "yyyy-MM-dd") ? "Missed Calls" : "Remaining Calls"}</span>
                <span className="ml-3 bg-[#FFE3DC] text-[#F27451] py-[2px] px-[4px] rounded font-semibold">{remainingCalls.toString().padStart(2, "0")} </span>
              </div>
            </div>
          </div>
        ) : (
          "Invalid Date"
        )}
      </div>
      <div className="h-[calc(100vh-289px)] overflow-y-auto">
        {[...Array(24)].map((_, i) => (
          <div
            key={i}
            className="grid grid-cols-[80px_1fr] border-b h-[67px] relative"
          >
            <div className="flex items-center justify-center text-gray-500 text-sm border-r table_border">
              {i}:00
            </div>
            <div className="relative h-full">
              <div className="absolute top-1/2 w-full border-t border-dotted"></div>
              <div className="flex h-full">
                {allEvents
                  .filter((event) => {
                    const eventStart = convertUTCToLocal(event.startTime);
                    return (
                      eventStart.dateOnly ===
                      format(validDate, "dd MMMM yyyy") &&
                      eventStart.hours === i
                    );
                  })
                  .map((event, index, filteredEvents) => {
                    const eventStart = convertUTCToLocal(event.startTime);
                    const width = `${100 / filteredEvents.length}%`;
                    const topOffset = (eventStart.minutes / 60) * 67; // Position inside the hour block

                    return (
                      <CalendarEventMins
                        key={index}
                        event={event}
                        onClick={(selected, position) => {
                          setSelectedEvent(selected);
                          setPopupPosition(position);
                        }}
                        isTooltipVisible={isTooltipVisible}
                        setTooltipVisible={setTooltipVisible}
                        style={{
                          width,
                          position: "relative",
                          top: `${topOffset}px`,
                        }}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Event Popup */}
      {selectedEvent && (
        <EventPopup
          setTrialInfo={setTrialInfo}
          event={selectedEvent}
          position={popupPosition}
          closePopup={closePopup}
          cancelMeeting={cancelMeeting}
          onClose={() => setSelectedEvent(null)}
          calOpen={calOpen}
          setCalOpen={setCalOpen}
          setMeetId={setMeetId}
          handleCall={handleCall}
          fetchEvents={fetchEvents}
          addToast={addToast}
        />
      )}
    </div>
  );
};

export default DayView;
